import React from 'react';
import Sidebar from "./Sidebar/Sidebar";
import Header from "./Header/Header";
import PropTypes from "prop-types";

const Layout = props => (
    <div className="layout">
      <Header/>
      <Sidebar auth={props.auth}/>
      {props.children}
    </div>
);

Layout.propTypes = {
  auth: PropTypes.object.isRequired
};

export default Layout;



// WEBPACK FOOTER //
// ./src/components/Layout/Layout.jsx